import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import { TrainingAndPractice } from 'containers/forms/dashboard'
import { DashboardGrid as Grid, ElevatedButton } from 'components/layout'
import { ACTIVITY_STATES, AWARD_STATES } from 'constants/enums'
import { CenteredContent, Note, CircleBadge } from 'components/misc'

import {
  apiAwards
} from 'helpers/decorators/api/dashboard'

const editable = [
  ACTIVITY_STATES.in_progress.id,
  ACTIVITY_STATES.setup.id,
  ACTIVITY_STATES.waiting_for_approval.id,
  ACTIVITY_STATES.assessment.id,
  ACTIVITY_STATES.award_leader_singoff.id
]

const completed = [
  ACTIVITY_STATES.complete.id,
  ACTIVITY_STATES.ceremony.id,
  ACTIVITY_STATES.office_signoff.id
]

const awardNotApproved = [
  AWARD_STATES.reg_assignment.id,
  AWARD_STATES.reg_not_approved.id,
  AWARD_STATES.reg_approval.id
]

const canSend = [ACTIVITY_STATES.assessment.id, ACTIVITY_STATES.in_progress.id]

const sendReportStyles = {
  borderBottom: '1px solid #ccc',
  paddingBottom: 25,
  marginBottom: 25
}

@connect(({ api }) => ({
  data: api.dashboard.awards.awards.data
}))
@apiAwards()
class AJPrepAndTrain extends Component {
  static propTypes = {
    data: PropTypes.object,
    colorClass: PropTypes.string,
    aJValues: PropTypes.object,
    params: PropTypes.object.isRequired,
    onSignOffRequestPT: PropTypes.func,
    fetchAward: PropTypes.func
  }

  handleSignOff = async() => {
    const { onSignOffRequestPT, fetchAward, params } = this.props

    const awardId = get(params, 'awardId')

    if (awardId) {
      const result = await onSignOffRequestPT(awardId)

      await fetchAward(awardId)
    }
  }

  render() {
    const { data, colorClass } = this.props

    const awardState = get(data, 'awardState.value')

    const state = get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingStateType.value'
    )
    const isEditable =
      editable.includes(state) && !awardNotApproved.includes(awardState)
    const isCompleted = completed.includes(state)
    const hasSomeData = get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingList',
      []
    ).some(item => get(item, 'isCompleted'))
    const isSendable = canSend.includes(state) && hasSomeData

    const ajPrepAndTrainState = get(data, 'ajPreparationAndTrainingStateType.value')

    return (<Grid.RightInner white>
        <div className="row">
          {isCompleted &&
          !isEditable && (
            <CenteredContent
              flex
              textAlign
              style={{ marginTop: '150px', flexDirection: 'column' }}
            >
              <CircleBadge colorClass={this.props.colorClass} large medal>
                <i className="ico ico--icon-victory" />
              </CircleBadge>
              <Note margin="25px 0 0 0">
                <FormattedHTMLMessage
                  id="label.your_journey_is_complete"
                  defaultMessage="Your {journeyType} Journey is complete."
                  values={{
                    journeyType: get(
                      event,
                      'ajEvent.ajEventCategory.translationText'
                    )
                  }}
                />
              </Note>
            </CenteredContent>
          )}

          {!isCompleted && (
            <div className="col-xs-12 col-md-7 col-lg-5">
              {isSendable && (
                <div style={sendReportStyles}>
                  <Note>
                    <FormattedMessage
                      id="label.you_can_send_report_to_award_leader"
                      defaultMessage="You can send your report to your Award Leader."
                    />
                  </Note>
                  <ElevatedButton
                    colorClass={colorClass}
                    uppercase
                    padded
                    onClick={this.handleSignOff}
                    intlKey="button.send_report"
                  >
                    Send Report
                  </ElevatedButton>
                </div>
              )}

              <TrainingAndPractice
                awardId={get(this.props.params, 'awardId')}
                disabled={!isEditable}
                ajPrepAndTrainState={ajPrepAndTrainState}
                noFooter
                noHeader
              />
            </div>
          )}
        </div>
      </Grid.RightInner>
    )
  }
}

export default AJPrepAndTrain
